

//import Breadcrumbs
import { Col, Container, Row } from "reactstrap";
import CardIcon from "src/components/Common/UI/CardIcon/CardIcon";
import { HiPhone } from "react-icons/hi2";
import { HiOutlineGlobeAlt } from "react-icons/hi2";
import { HiOutlineBuildingOffice } from "react-icons/hi2";
import { HiOutlineMap } from "react-icons/hi";
import { HiOutlineCube } from "react-icons/hi";
import { HiOutlineCreditCard } from "react-icons/hi";
import { HiOutlineMapPin } from "react-icons/hi2";
import { HiOutlineBuildingOffice2 } from "react-icons/hi2";
import { useGetDashboard } from "./hooks/getDashboard";
import LoadingSpinner from "src/components/Common/UI/LoadingSpinner/LoadingSpinner";
import { NavLink } from "react-router-dom";


const Dashboard = () => {
  const getDasboardQuery = useGetDashboard();

  if (getDasboardQuery.isLoading) {
    return (
      <Container fluid>
          <Row>
            <Col xs={12}>
              <LoadingSpinner />
            </Col>
          </Row>
      </Container>
    );
  }

  if (!getDasboardQuery.data) return null;

  return (
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xs={12} md={6} xl={6} className="col-xxl-3">
              <NavLink to='/phone-charges/phone-lines'>
                <CardIcon
                  title="Τηλεφωνικές Γραμμές"
                  value={`${getDasboardQuery.data.phoneLines}`}
                  footer="Ενεργές"
                  icon={HiPhone}
                  iconColor="#4fa6c7"
                />
              </NavLink>
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/linesandnodes/lines'>
              <CardIcon
                title="Γραμμές Data"
                value={`${getDasboardQuery.data.dataLines}`}
                footer="Ενεργές"
                icon={HiOutlineGlobeAlt}
                iconColor="#4BD4D6"
              />
             </NavLink> 
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/unitconfiguration/establishments'>
              <CardIcon
                title="Καταστήματα"
                value={`${getDasboardQuery.data.establishments}`}
                footer="Ενεργές"
                icon={HiOutlineBuildingOffice}
                iconColor="#5FEDC7"
              />
            </NavLink>  
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/unitconfiguration/departments'>
              <CardIcon
                title="Διευθύνσεις"
                value={`${getDasboardQuery.data.departments}`}
                footer="Ενεργές"
                icon={HiOutlineMap}
                iconColor="#39a24a"
              />
            </NavLink>  
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/unitconfiguration/units'>
              <CardIcon
                title="Μονάδες"
                value={`${getDasboardQuery.data.units}`}
                footer="Ενεργές"
                icon={HiOutlineCube}
                iconColor="#6FCF97"
              />
            </NavLink>  
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/unitconfiguration/atms'>
              <CardIcon
                title="ΑΤΜ"
                value={`${getDasboardQuery.data.atms}`}
                footer="Ενεργές"
                icon={HiOutlineCreditCard}
                iconColor="#9B51E0"
              />
            </NavLink>  
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/unitconfiguration/dcompanies'>
              <CardIcon
                title="Θυγατρικές"
                value={`${getDasboardQuery.data.dCompanies}`}
                footer="Ενεργές"
                icon={HiOutlineBuildingOffice2}
                iconColor="#56CCF2"
              />
            </NavLink>  
            </Col>

            <Col xs={12} md={6} xl={6} className="col-xxl-3">
            <NavLink to='/configuration/parameters/geographicals'>
              <CardIcon
                title="Τοποθεσίες"
                value={`${getDasboardQuery.data.places}`}
                footer="Ενεργές"
                icon={HiOutlineMapPin}
                iconColor="#F2994A"
              />
            </NavLink>  
            </Col>
          </Row>
        </Container>
      </div>
  );
};

export default Dashboard;
